import React, { useState, useEffect } from "react";
import { renderToString } from 'react-dom/server'
import { Row, Col, Button } from "reactstrap";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as FontAwesomeIcons from "@fortawesome/free-solid-svg-icons";
import * as EntypoIcons from "react-entypo";

//Components
import CustomMap from "../../../../components/CustomMap";
import ModalCustomized from "../../../../components/Modal/Modal";
import TabelaListagem from "../../../../components/TabelaListagem/TabelaListagem";

//Assets
import { customIcon } from "../../../../assets/Icons/Icons";

//Constants
import { actionsTable } from "../../../../constants/MaterialTable";

export default function MapaDeCacambas({
    pontosMapa = [],
    tipoFiscalizacao,
    loadFormulario,
    setShowButtons,
    dadosIntegracao = null,
    setActiveStep
}) {
    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);
    const toggleModal = () => setVisibleModal(!visibleModal);

    //Cabeçalhos da lista de consulta infração
    const headers = [
        { value: "Documento de identificação", objectValue: "documentoIdentificacao", align: "left" },
        { value: "Nome/Razão social", objectValue: "nomeRazao", align: "left" },
        { value: "Nome Fantasia", objectValue: "nomeFantasia", align: "left" },
        { value: "Código do item", objectValue: "codigo", align: "left" }
    ];

    //Função que salva os dados da caçamba para visualização na tabela de agrumamentos de pontos
    const visualizarDadosCacamba = (rowData) => {
        loadFormulario(tipoFiscalizacao, rowData);
    }

    //Ações da tabela
    const actions = [
        actionsTable.visualizar(visualizarDadosCacamba)
    ]

    //função responsavel por ir para a tela de formulario
    const fiscalizarItem = () => {
        setActiveStep(prev => prev + 1);
        setShowButtons(true);
    };

    //função de onChange do marker no mapa
    const onChangeMarker = (ponto) => {
        if (ponto.solicitacaoFiscalizacao)
            return;
        loadFormulario(tipoFiscalizacao, ponto);
        toggleModal();
    }

    //Função que pega o icone do marker do mapa
    const getIcon = (ponto) => {
        if (ponto.nomeIcone) {
            if (ponto.fonteIcone == "FontAwesome5")
                return <FontAwesomeIcon icon={FontAwesomeIcons[ponto.nomeIcone]} color={ponto.corIcone == "#fff" || ponto.corIcone == "#ffffff" ? "#666" : "#fff"} />
            else if (ponto.fonteIcone == 'Entypo') {
                const EntypoIcon = EntypoIcons[ponto.nomeIcone];
                if (EntypoIcon)
                    return <EntypoIcon size={"24"} color={ponto.corIcone == "#fff" || ponto.corIcone == "#ffffff" ? "#666" : "#fff"} />
            }
        }
        return null;
    }

    useEffect(() => {
        setShowButtons(false);
    }, []);
    return (
        <Row>
            <ModalCustomized title={dadosIntegracao && !dadosIntegracao.lista ? dadosIntegracao.codigo : "Escolha um item da lista"} isOpen={visibleModal} toggle={toggleModal} btnClose>

                {
                    dadosIntegracao && dadosIntegracao.lista
                        ?
                        <TabelaListagem title="Lista de items" headers={headers} items={dadosIntegracao.lista} actions={actions} />
                        :
                        <Row className="text-secondary">
                            {dadosIntegracao?.dataUltimaFiscalizacao &&
                                <Col md="12" className="text-danger">
                                    <p> Já existe um auto de fiscalização na data <span className="fw-bold">{moment(dadosIntegracao.dataUltimaFiscalizacao).format("DD/MM/YYYY")}</span></p>
                                </Col>
                            }
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Documento de identificação: </span> {dadosIntegracao?.documentoIdentificacao ?? ""}</p>
                            </Col>
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Nome / Razão social: </span> {dadosIntegracao?.nomeRazao ?? ""}</p>
                            </Col>
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Nome / Razão social: </span> {dadosIntegracao?.nomeRazao ?? ""}</p>
                            </Col>
                            <Col md="12" lg="6">
                                <p><span className="fw-bold">Código do item: </span> {dadosIntegracao?.codigo ?? ""}</p>
                            </Col>
                            {dadosIntegracao?.dadosAdicionais && dadosIntegracao?.dadosAdicionais.map((value, key) => {
                                return (
                                    <Col md="12" lg="6" key={key}>
                                        <p><span className="fw-bold">{value.campo}:</span>{value.valor}</p>
                                    </Col>
                                )
                            })
                            }
                            <Col md="12" className="d-flex align-items-center justify-content-center mt-3">
                                <Button className="px-5" color="success" onClick={() => fiscalizarItem()}>
                                    Fiscalizar
                                </Button>
                            </Col>
                        </Row>
                }
            </ModalCustomized>
            <Col className="mb-3" md="12" style={{ height: "350px" }}>
                <CustomMap
                    positionCenter
                    onClickMarker={onChangeMarker}
                    zoom={25}
                    markers={pontosMapa.map(value => {
                        value.coordenadas = [value.latitude, value.longitude];
                        return value;
                    })}
                    icone={(ponto) => {
                        const customMarker =
                            <div className="d-flex align-items-center justify-content-center rounded-circle pinCustomMarker" style={{ backgroundColor: ponto.corIcone, width: "24px", height: "24px" }}>
                                {getIcon(ponto)}
                            </div>;
                        return customIcon(
                            renderToString(customMarker)
                        );
                    }}
                />
            </Col>
        </Row>
    )
}